export interface PickupDiffStatusEnum {
  value: number
  name: string
  i18nKey: string
}

export const pickupDiffStatusEnumList: PickupDiffStatusEnum[] = [
  {value: 0, name: "UNKNOWN", i18nKey: "entity.pickup_diff.status.unknown"},
  {value: 100, name: "CREATED", i18nKey: "entity.pickup_diff.status.created"},
  {value: 102, name: "DELETED", i18nKey: "entity.pickup_diff.status.deleted"},
  {value: 103, name: "ERROR", i18nKey: "entity.pickup_diff.status.error"},
  {value: 104, name: "CREATION_SENT", i18nKey: "entity.pickup_diff.status.creation_sent"},
  {value: 105, name: "CANCELLATION_SENT", i18nKey: "entity.pickup_diff.status.cancellation_sent"},
  {value: 106, name: "CANCELLING", i18nKey: "entity.pickup_diff.status.cancelling"},
  {value: 999, name: "IMPORT_FAILED", i18nKey: "entity.pickup_diff.status.import_failed"},
  {value: 1000, name: "IMPORTED", i18nKey: "entity.pickup_diff.status.imported"},
  {value: 1001, name: "PENDING", i18nKey: "entity.pickup_diff.status.pending"},
  {value: 1002, name: "SCHEDULED_1", i18nKey: "entity.pickup_diff.status.scheduled_1"},
  {value: 1003, name: "SCHEDULED_2", i18nKey: "entity.pickup_diff.status.scheduled_2"},
  {value: 1004, name: "OPEN_REJECTED", i18nKey: "entity.pickup_diff.status.open_rejected"},
  {value: 1005, name: "ACCEPTED", i18nKey: "entity.pickup_diff.status.accepted"},
  {value: 1006, name: "PICKUP_PROBLEM_1", i18nKey: "entity.pickup_diff.status.pickup_problem_1"},
  {value: 1007, name: "PICKUP_PROBLEM_2", i18nKey: "entity.pickup_diff.status.pickup_problem_2"},
  {value: 1008, name: "COMPLETED", i18nKey: "entity.pickup_diff.status.completed"},
  {value: 1009, name: "CANCELLED", i18nKey: "entity.pickup_diff.status.cancelled"}
]
